import React from 'react';
import glamorous from 'glamorous';
import Circular, {BUTTON} from '../../../../shared/library/indicators/indeterminate/circular';
import SmallTitle from '../../../../shared/library/typography/small-title';

const ListItem = glamorous.li({
  display: 'flex',
  alignItems: 'center',
  padding: '5px 10px'
});

const Indicator = glamorous(Circular)({
  marginRight: 8
});

export default function ComparisonLoadingIndicator() {
  return (
    <ListItem>
      <Indicator size={BUTTON} />
      <SmallTitle>Searching...</SmallTitle>
    </ListItem>
  );
}
